import { Ability } from "@casl/ability";

const baseRoutes: {
  action: string;
  subject: string;
}[] = [];
export const ability = new Ability(baseRoutes);
